var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main"},[_c('el-tabs',{attrs:{"type":"border-card"},model:{value:(_vm.tabAtiva),callback:function ($$v) {_vm.tabAtiva=$$v},expression:"tabAtiva"}},[_c('el-tab-pane',{attrs:{"label":"FALTAS","name":"0"}},[_c('list-faltas')],1),_c('el-tab-pane',{attrs:{"label":"NOTAS","name":"1"}},[_c('list-faltas')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }